import templateDefaults from '../templateDefaults';

const TGB_ASSETS_URL = process.env.TGB_ASSETS_CDN_URL;

export default {
  previewImage: '/img/event/l3-two-lines.png',
  title: '2-Line Lower Third',
  templateData() {
    return {
      version: 'v1.1',
      title: 'Event Lower Third Two Lines',
      ...templateDefaults,
      elements: [
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Text line 2',
          locked: false,
          text: '<p><strong>dolor sit amet, adipiscing elit, sed do eiusmod tempor</strong></p>',
          cssClasses: '',
          animation: true,
          animationInStyle: 'fadeIn',
          animationInDuration: 300,
          animationInDelay: 900,
          animationInEasing: '0.420, 0.000, 1.000, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 300,
          animationOutDelay: 0,
          animationOutEasing: '0.000, 0.000, 0.580, 1.00',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          fitText: false,
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 947,
            left: 246,
            width: 1230,
            height: 47,
            opacity: 1,
            color: '#000000',
            fontFamily: 'Montserrat',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 36,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 0,
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Text line 1',
          locked: false,
          text: '<p><strong>This is the main first line of text at 36pt, lorem ipsum</strong></p>',
          cssClasses: '',
          animation: true,
          animationInStyle: 'fadeIn',
          animationInDuration: 300,
          animationInDelay: 900,
          animationInEasing: '0.420, 0.000, 1.000, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 300,
          animationOutDelay: 0,
          animationOutEasing: '0.000, 0.000, 0.580, 1.00',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          fitText: false,
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 900,
            left: 246,
            width: 1230,
            height: 47,
            opacity: 1,
            color: '#000000',
            fontFamily: 'Montserrat',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 36,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 0,
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'White rectangle',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: true,
          animationInStyle: 'slideInLeft',
          animationInDuration: 300,
          animationInDelay: 600,
          animationInEasing: '0.420, 0.000, 1.000, 1.000',
          animationOutStyle: 'slideOutLeft',
          animationOutDuration: 300,
          animationOutDelay: 300,
          animationOutEasing: '0.000, 0.000, 0.580, 1.00',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          fillStyle: 'solid',
          backgroundColor: 'rgb(255, 255, 255)',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          skewX: 0,
          skewY: 0,
          rotate: 0,
          styles: {
            top: 890,
            left: 226,
            width: 1270,
            height: 114,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'image',
          name: 'Logo',
          editable: true,
          locked: false,
          aspectLock: true,
          mask: false,
          maskShape: 'oval',
          imageUrl: `${TGB_ASSETS_URL}/logos/tagboard-hash-blue.svg`,
          cssClasses: '',
          animation: true,
          animationInStyle: 'fadeIn',
          animationInDuration: 300,
          animationInDelay: 600,
          animationInEasing: '0.420, 0.000, 1.000, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 300,
          animationOutDelay: 300,
          animationOutEasing: '0.000, 0.000, 0.580, 1.00',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          fillType: 'stretch',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          styles: {
            top: 920,
            left: 127,
            width: 68,
            height: 60,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Black rectangle',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: true,
          animationInStyle: 'slideInUp',
          animationInDuration: 300,
          animationInDelay: 300,
          animationInEasing: '0.420, 0.000, 1.000, 1.000',
          animationOutStyle: 'slideOutDown',
          animationOutDuration: 300,
          animationOutDelay: 600,
          animationOutEasing: '0.000, 0.000, 0.580, 1.00',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          fillStyle: 'solid',
          backgroundColor: 'rgb(0, 0, 0)',
          backgroundSize: 'contain',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          skewX: 0,
          skewY: 0,
          rotate: 0,
          styles: {
            top: 890,
            left: 96,
            width: 130,
            height: 120,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Gradient rectangle',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: true,
          animationInStyle: 'slideInLeft',
          animationInDuration: 300,
          animationInDelay: 0,
          animationInEasing: '0.420, 0.000, 1.000, 1.000',
          animationOutStyle: 'slideOutLeft',
          animationOutDuration: 300,
          animationOutDelay: 900,
          animationOutEasing: '0.000, 0.000, 0.580, 1.00',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          fillStyle: 'gradient',
          backgroundColor: '#0F84FB',
          backgroundSize: 'cover',
          gradientDirection: 90,
          gradientColorOne: 'rgb(204, 0, 127)',
          gradientColorTwo: 'rgb(255, 208, 19)',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          skewX: 0,
          skewY: 0,
          rotate: 0,
          styles: {
            top: 1004,
            left: 226,
            width: 1270,
            height: 6,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Thin white line',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: true,
          animationInStyle: 'slideInLeft',
          animationInDuration: 300,
          animationInDelay: 0,
          animationInEasing: '0.420, 0.000, 1.000, 1.000',
          animationOutStyle: 'slideOutLeft',
          animationOutDuration: 300,
          animationOutDelay: 900,
          animationOutEasing: '0.000, 0.000, 0.580, 1.00',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          fillStyle: 'solid',
          backgroundColor: 'rgb(255, 255, 255)',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          skewX: 0,
          skewY: 0,
          rotate: 0,
          styles: {
            top: 1022,
            left: 96,
            width: 1400,
            height: 4,
            opacity: 1,
          },
        },
      ],
    };
  },
};
